import React from 'react';
import { StyledGuestDirectoryExternalLinkButton } from './styles';

interface Props {
  label: React.ReactNode;
  href: string;
  buttonColour?: string | null;
  buttonBg?: string | null;
  buttonBorder?: string | null;
}

const isSafeExternalUrl = (url: string): boolean => url.startsWith('https://') || url.startsWith('http://');

const GuestDirectoryExternalLinkButton: React.FC<Props> = ({
  label,
  href,
  buttonColour,
  buttonBg,
  buttonBorder,
}) => {
  if (!isSafeExternalUrl(href)) {
    return null;
  }

  return (
    <StyledGuestDirectoryExternalLinkButton
      label={label}
      to={href}
      forceReload={true}
      openInNewWindow={true}
      buttonColour={buttonColour}
      buttonBg={buttonBg}
      buttonBorder={buttonBorder}
    />
  );
};

export default GuestDirectoryExternalLinkButton;
